<template lang="pug">
nav.navbar(role="navigation" aria-label="main navigation")
  .navbar-brand
    router-link.navbar-item(:to="{ name: 'Wall' }")
      img(:src="logo" alt='Logo' style='width: 80px; height: 60px; object-fit: contain; max-height: none;')

    a.navbar-burger.burger(
      href='javascript:void(0)'
      role="button"
      aria-label="menu"
      aria-expanded="false"
      @click="handleBurgerClick"
      :class="{ 'is-active': burgerOpen }")
      span(aria-hidden="true")
      span(aria-hidden="true")
      span(aria-hidden="true")

  .navbar-menu(:class="{ 'is-active': burgerOpen }")
    .navbar-start
      router-link.navbar-item(:to="{ name: 'Wall' }") Muro

      .navbar-item.has-dropdown.is-hoverable(v-if="puedeUsuarios || puedeGrupos")
        a.navbar-link(href='javascript:void(0)') Colegio

        .navbar-dropdown
          router-link.navbar-item(to="/usuarios" v-if="puedeUsuarios") Usuarios
          router-link.navbar-item(to="/grupos" v-if="puedeGrupos") Grupos
        
      .navbar-item.has-dropdown.is-hoverable(v-if="isSuper")
        a.navbar-link(href='javascript:void(0)') Configuración

        .navbar-dropdown
          router-link.navbar-item(:to="{ name: 'configColegios' }") Colegios
          router-link.navbar-item(:to="{ name: 'configUsuarios' }") Asignar usuarios

    .navbar-end
      .navbar-item.has-dropdown.is-hoverable
        a.navbar-link(href='javascript:void(0)') {{ userEmail }}

        .navbar-dropdown.is-right
          //- router-link.navbar-item(to="/perfil") Perfil

          //- hr.navbar-divider
          
          a.navbar-item(
            href='javascript:void(0)'
            v-for="colegio in colegios_validos"
            :class="{ 'is-active': idCole === colegio.id }"
            @click="setCole(colegio.id)"
          ) {{ colegio.nombre }}

          hr.navbar-divider

          a.navbar-item.button.is-warning.is-light(href='javascript:void(0)' @click="logoutAction" style="margin: 10px 10px 0px 10px") Cerrar sesión
</template>

<style scoped>
.logoText {
  font-family: "Nunito", sans-serif;
  color: #3293cc;
  font-size: 1.3rem;
}
</style>

<script>
import _get from "lodash/get";
import logo from "../assets/logo.png";
import { mapActions, mapState } from "vuex";

export default {
  name: "TopHeader",

  data: () => ({
    burgerOpen: false,
    logo
  }),

  created() {
    window.addEventListener("click", evt => this.handleGlobalClick(evt));
  },

  watch: {
    colegios_list() {
      this.checkAvailableCole();
    },
    colegios_sel() {
      this.checkAvailableCole();
    }
  },

  computed: {
    ...mapState(["colegios_list", "colegios_sel", "user"]),

    colegios_validos() {
      return this.colegios_list.filter(cole =>
        this.listOfColegios.find(lsCole => lsCole === cole.id)
      );
    },

    userEmail() {
      const userName = _get(this.user, "email", "Usuario");
      let newNombre =
        userName.indexOf("@") > -1 ? userName.split("@")[0] : userName;
      if (this.colegios_sel)
        newNombre = newNombre + ` en ${this.colegios_sel.nombre}`;
      return newNombre;
    },

    listOfColegios() {
      return Object.keys(_get(this.user, "userInfo.permisos") || {});
    },

    isSuper() {
      return !!_get(this.user, "userInfo.superuser");
    },

    puedeUsuarios() {
      if (this.isSuper) return true;
      if (!this.colegios_sel) return false;
      return (
        !!_get(
          this.user,
          `userInfo.permisos.${this.colegios_sel.id}.usuarios.creacion`
        ) ||
        !!_get(
          this.user,
          `userInfo.permisos.${this.colegios_sel.id}.usuarios.modificacion`
        )
      );
    },

    puedeGrupos() {
      if (this.isSuper) return true;
      if (!this.colegios_sel) return false;
      return (
        !!_get(
          this.user,
          `userInfo.permisos.${this.colegios_sel.id}.grupos.creacion`
        ) ||
        !!_get(
          this.user,
          `userInfo.permisos.${this.colegios_sel.id}.grupos.modificacion`
        )
      );
    },

    idCole() {
      return _get(this.colegios_sel, "id");
    }
  },

  methods: {
    ...mapActions(["logoutAction", "setOneColegio"]),
    async setCole(id) {
      if (id) {
        await this.setOneColegio(id);
        localStorage.setItem("ColeActual", id);
      }
    },
    checkAvailableCole() {
      const id = localStorage.getItem("ColeActual");
      if (this.colegios_validos.length && !this.colegios_sel && !id) {
        this.setCole(this.colegios_validos[0].id);
      } else if (this.colegios_validos.length && !this.colegios_sel && id) {
        this.setCole(id);
      } else if (
        (this.colegios_sel &&
          !this.colegios_validos.find(
            cng => cng.id === this.colegios_sel.id
          )) ||
        !this.colegios_validos.length
      ) {
        localStorage.removeItem("ColeActual");
        this.logoutAction();
      }
    },
    handleBurgerClick() {
      this.burgerOpen = !this.burgerOpen;
    },
    handleGlobalClick(evnt) {
      if (!evnt.target.classList.contains("navbar-burger"))
        this.burgerOpen = false;
    }
  }
};
</script>
